import { CoreApiClient } from './coreApiClient';

const api = new CoreApiClient('', (...args) => fetch(...args));
const path = '/api/v1/mcp/project-assistant/';
export interface MailReviewRow {
  messageId:string; subject:string; fromEmail:string; occurredAt:string; direction:'inbound'|'outbound';
  sourceUrl:string; excerpt:string; nextAction:string; reason:string;
  urgency:'urgent'|'time_sensitive'|'normal'; urgencyReason:string|null;
  candidates:Array<{projectId:number; projectNumber:string; address:string; status:string|null; basis:string}>;
}
export interface MailReviewPage {
  contractVersion:string; mailbox:string; revision:number; total:number; legacyUnresolved:number;
  enrollmentRequired:boolean; candidateCoverage:'available'|'unavailable'; nextCursor:string|null; items:MailReviewRow[];
}

export async function readAllMailReviews():Promise<MailReviewPage> {
  let cursor:string|null = null;
  let first:MailReviewPage|undefined;
  const items:MailReviewRow[] = [];
  const visited = new Set<string>();
  let candidateCoverage:MailReviewPage['candidateCoverage'] = 'available';
  do {
    const {data:page} = await api.request<{data:MailReviewPage}>(path+'unmatched-review',{query:{pageSize:25,cursor}});
    if (page?.contractVersion !== 'assistant-unmatched-review-v1' || !Array.isArray(page.items) ||
      !Number.isSafeInteger(page.revision) || !Number.isSafeInteger(page.total) || (first && (first.revision !== page.revision || first.mailbox !== page.mailbox || first.total !== page.total))) {
      throw new Error('Mail review changed during loading. Refresh to read the current list.');
    }
    first ??= page;
    if (page.candidateCoverage === 'unavailable') candidateCoverage = 'unavailable';
    items.push(...page.items);
    cursor = page.nextCursor;
    if (cursor && visited.has(cursor)) throw new Error('Mail review returned a repeated page.');
    if (cursor) visited.add(cursor);
  } while (cursor);
  if (items.length !== first!.total || new Set(items.map(row=>row.messageId)).size !== items.length) {
    throw new Error('The complete review list could not be loaded.');
  }
  return {...first!, items, candidateCoverage, nextCursor:null};
}

export async function confirmMailProject(messageId:string,projectId:number,expectedRevision:number) {
  const {data} = await api.request<{data:{suggestionId:string; revision:number}}>(path+'confirm-unmatched',{
    method:'POST',body:{messageId,projectId,expectedRevision}
  });
  if (!data?.suggestionId) throw new Error('Refresh to verify whether the project link was saved.');
  return data;
}
